import Swal from "sweetalert2";

const loadInstructions = text => {
  const ToastSearch = Swal.mixin({
    toast: true,
    position: window.innerWidth <= "475" ? "top-start" : "top",
    showConfirmButton: false,
    timer: 5000
  });
  ToastSearch.fire({
    type: "info",
    title: "Consulta:",
    text: text
  });
};

export default loadInstructions;
